require('jquery-ui-bundle');

window.SmoothScrollOptions = { 
    animationTime       : 1500,
    accelerationDelta   : 50,  
    accelerationMax     : 1 
}
require('../../node_modules/smoothscroll-for-websites/SmoothScroll');
require('../../node_modules/simplelightbox/dist/simple-lightbox.min.js');

import { gsap }                 from "gsap";
import { ScrollTrigger }        from "gsap/ScrollTrigger";
import { ScrollToPlugin }       from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin); 

import * as Menu                from "./components/Menu";
import * as Search              from "./components/Search";


import AjaxLoadPage             from "./components/AjaxLoadPage";
import ScrollEvents             from "./components/ScrollEvents";
import SwiperGalleries      from './components/SwiperGallery';
import * as Intros              from "./components/IntroPage";
import * as mask                from "./components/jqMask";
import * as jqValidate          from "./components/JqValidate";
// import * as Gallery             from "./components/Gallery";
import * as Svg                 from "./components/Svg";
import * as ModalVideo          from "./components/ModalVideo";
import * as Grid                from "./components/Grid";
import * as SimpleLightbox      from "./components/SimpleLightBox";
import * as FormAjax 			from "./components/FormAjax";
import * as FormReserve 	    from "./components/FormReserve";
import * as CustomDropdown		from "./components/CustomDropdown";
import * as CustomSwitch        from "./components/Switch";
import * as ModalInfo           from "./components/ModalInfo";


// loader site
document.onreadystatechange = function () {
    //AjaxLoadPage.init(1);
    jqValidate.formAjax();
    if (document.readyState == "complete") {
        app();
    }
}

const app = () => {
    AjaxLoadPage.init(0);
    Menu.init();
    update();
}


window.update = () =>{
    Search.init();
    Intros.init();
    mask.inputsMask();
    FormAjax.init();
    FormReserve.init();
    Grid.init();
    ScrollEvents.init();
    CustomDropdown.init();
    CustomSwitch.init();
    ModalInfo.init();
    SwiperGalleries.init();
    jqValidate.formAjax();
    ModalVideo.init();   
    SimpleLightbox.init(); 
    setTimeout(()=>{
        Svg.init();
    },500);

    setTimeout(() => {
        $(".datepicker").datepicker({
            dateFormat: 'dd/mm/yy',
            language: "pt-BR",
            autoclose: true,
            minDate: 1,
            min: 1,
            defaultDate: "+1d",
            // nextText: ">",
            // prevText: "<",
            dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
            dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            nextText: 'Próximo',
            prevText: 'Anterior'
        });        
    }, 500);

}

